/* PROCESSOS */
export const GET_PROCESSOS = "GET_PROCESSOS"
export const GET_PROCESSO_COMPLETO = "GET_PROCESSO_COMPLETO"
export const GET_PROCESSOS_SUCCESS = "GET_PROCESSOS_SUCCESS"
export const GET_PROCESSOS_FAIL = "GET_PROCESSOS_FAIL"
export const UPDATE_PROCESSO = "UPDATE_PROCESSO"
export const UPDATE_PROCESSO_SUCCESS = "UPDATE_PROCESSO_SUCCESS"
export const UPDATE_PROCESSO_FAIL = "UPDATE_PROCESSO_FAIL"
export const POST_PROCESSO_SUCCESS = "POST_PROCESSO_SUCCESS"
export const POST_PROCESSO_MSG = "POST_PROCESSO_MSG"
export const RESET_PROCCESS_MESSAGES = "RESET_PROCCESS_MESSAGES"
